/**
 * @desc 物流报价方案-删除附加费
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(id: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/surcharge/${id}`, {
      method: "DELETE",

      ...options,
    }),
  );
}
